import { LinkButton } from '#components/atoms/buttons/link-button/LinkButton.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import { Spacer } from '#components/patterns/spacer/Spacer.tsx';

type Props = {
  addOIDCHref: string;
};

export function EmptySSOSettings({ addOIDCHref }: Props) {
  return (
    <CenteredLayout>
      <div>
        <h2 className="h3 mb-16">You haven’t set up SSO</h2>
        <p className="p-lt mb-24">
          Single Sign-On (SSO) lets your team of administrators configure your Managed Nebula network, and can also be
          set up to allow your other employees to securely access resources on the network from endpoint devices. See
          our{' '}
          <a className="a inline" href="https://www.defined.net/docs/guides/setting-up-sso/" target="_blank" rel="help">
            setup guide
          </a>
          .
        </p>
        <Spacer size="wide">
          <LinkButton to={addOIDCHref}>Add OIDC provider</LinkButton>
        </Spacer>
      </div>
    </CenteredLayout>
  );
}
